<div class="form-group">
  <label for="prod-m">{{ 'attributeManagement.label.state'| translate }}</label>
  <angular2-multiselect [data]="statesList"
      [(ngModel)]="stateSelected"
      [settings]="computedSettings"
      (onSelect)="onStateSelect()">
  </angular2-multiselect>
</div>